export type CameraMode = "follow" | "fpv" | "free";
export type MapStyle = "photo" | "classic";

interface ReplayControlsProps {
  playing: boolean;
  elapsed: number;
  total: number;
  speed: number;
  onPlay: () => void;
  onPause: () => void;
  onSeek: (value: number) => void;
  onSpeedChange: (value: number) => void;
  onReset: () => void;
}

function fmt(seconds: number): string {
  const s = Math.floor(seconds % 60);
  const m = Math.floor(seconds / 60);
  return `${m}:${String(s).padStart(2, "0")}`;
}

const SPEEDS = [0.25, 0.5, 1, 2, 4, 8];

export function ReplayControls({
  playing,
  elapsed,
  total,
  speed,
  onPlay,
  onPause,
  onSeek,
  onSpeedChange,
  onReset,
}: ReplayControlsProps) {
  return (
    <div className="rhud-timeline">
      <button
        className="rhud-tl-btn rhud-tl-btn--reset"
        type="button"
        onClick={onReset}
        title="Restart"
        aria-label="Restart"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="1 4 1 10 7 10" />
          <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
        </svg>
      </button>

      <button
        className="rhud-tl-btn rhud-tl-btn--play"
        type="button"
        onClick={() => (playing ? onPause() : onPlay())}
        title={playing ? "Pause" : "Play"}
        aria-label={playing ? "Pause" : "Play"}
      >
        {playing ? (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <rect x="6" y="5" width="4" height="14" rx="1" />
            <rect x="14" y="5" width="4" height="14" rx="1" />
          </svg>
        ) : (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="6 4 20 12 6 20" />
          </svg>
        )}
      </button>

      <span className="rhud-tl-time rhud-tl-time--elapsed">{fmt(elapsed)}</span>

      <input
        className="rhud-tl-scrubber"
        type="range"
        min={0}
        max={total}
        step={0.05}
        value={elapsed}
        onChange={(e) => onSeek(Number(e.target.value))}
        aria-label="Scrub timeline"
      />

      <span className="rhud-tl-time rhud-tl-time--total">{fmt(total)}</span>

      <div className="rhud-tl-speed">
        {SPEEDS.map((s) => (
          <button
            key={s}
            type="button"
            className={`rhud-tl-speed-btn${speed === s ? " active" : ""}`}
            onClick={() => onSpeedChange(s)}
          >
            {s}×
          </button>
        ))}
      </div>
    </div>
  );
}
